if(typeof(register_errors) !== 'undefined' && document.querySelector('.js-tkit-loading-form')) {
    $(".js-tkit-loading-form").validate({
        onkeyup: false,
        focusCleanup: true,
        errorElement: "span",
        rules: {
            admin_email: {
                email: true
            },
        },

        messages: {
            storename: {
                required: register_errors.name,
            },

            admin_email: {
                email: register_errors.admin_email_valid,
                required: register_errors.admin_email,
            },

            password: {
                required: register_errors.password,
            },

            accept_tos: {
                required: register_errors.accept_tos,
            },

            'partner[name]': {
                required: register_errors.name,
            },

            'partner[email]': {
                email: register_errors.admin_email_valid,
                required: register_errors.admin_email,
            },

            'partner[password]': {
                required: register_errors.password,
            },

            'partner[accept_tos]': {
                required: register_errors.accept_tos_generic,
            },
        },
        submitHandler: function(form) {
            form.submit();
        }
    });
}